{
  "about.blocks": "මැදිහත්කරණ සේවාදායක",
  "about.contact": "සබඳතාව:",
  "about.default_locale": "Default",
  "about.disclaimer": "මාස්ටඩන් යනු නිදහස් විවෘත මූලාශ්‍ර මෘදුකාංගයකි. එය මාස්ටඩන් gGmbH හි වෙළඳ නාමයකි.",
  "about.domain_blocks.no_reason_available": "හේතුව ලබා ගත නොහැක.",
  "about.domain_blocks.preamble": "Mastodon සාමාන්‍යයෙන් ඔබට fediverse හි වෙනත් ඕනෑම සේවාදායකයකින් අන්තර්ගතයන් බැලීමට සහ පරිශීලකයින් සමඟ අන්තර් ක්‍රියා කිරීමට ඉඩ සලසයි. මෙම විශේෂිත සේවාදායකයේ සිදු කර ඇති ව්‍යතිරේක මේවාය.",
  "about.domain_blocks.silenced.explanation": "ඔබ එය පැහැදිලිව සොයා බැලුවහොත් හෝ අනුගමනය කිරීමෙන් එයට සම්බන්ධ නොවන්නේ නම්, සාමාන්‍යයෙන් ඔබට මෙම සේවාදායකයෙන් පැතිකඩ සහ අන්තර්ගතයන් නොපෙනේ.",
  "about.domain_blocks.silenced.title": "සීමිතයි",
  "about.domain_blocks.suspended.explanation": "මෙම සේවාදායකයෙන් ලැබෙන කිසිදු දත්තයක් සැකසීම, ගබඩා කිරීම හෝ හුවමාරු කිරීම සිදු නොකෙරේ, මෙම සේවාදායකයෙන් පැමිණෙන පරිශීලකයින් සමඟ කිසිදු අන්තර්ක්‍රියාවක් හෝ සන්නිවේදනයක් කළ නොහැකි වේ.",
  "about.domain_blocks.suspended.title": "අත්හිටුවා ඇත",
  "about.not_available": "මෙම තොරතුරු මෙම සේවාදායකයේ ලබා ගත හැකි කර නොමැත.",
  "about.powered_by": "{mastodon}මගින් බල ගැන්වෙන විමධ්‍යගත සමාජ මාධ්‍ය",
  "about.rules": "සේවාදායකයේ නීති",
  "account.account_note_header": "පුද්ගලික සටහන",
  "account.add_or_remove_from_list": "ලැයිස්තු වලින් එකතු හෝ ඉවත් කරන්න",
  "account.badges.bot": "ස්වයංක්‍රියයි",
  "account.badges.group": "සමූහය",
  "account.block": "@{name} අවහිර කරන්න",
  "account.block_domain": "{domain} වසම අවහිර කරන්න",
  "account.block_short": "අවහිර",
  "account.blocked": "අවහිර කර ඇත",
  "account.cancel_follow_request": "අනුගමනය කිරීම අවලංගු කරන්න",
  "account.copy": "පැතිකඩට සබැඳිය පිටපත් කරන්න",
  "account.direct": "පෞද්ගලිකව @{name}සඳහන් කරන්න",
  "account.disable_notifications": "@{name} පළ කරන විට මට දැනුම් නොදෙන්න",
  "account.edit_profile": "පැතිකඩ සංස්කරණය",
  "account.enable_notifications": "@{name} පළ කරන විට මට දැනුම් දෙන්න",
  "account.endorse": "පැතිකඩෙහි විශේෂාංගය",
  "account.familiar_followers_many": "{name1}, {name2}, සහ {othersCount, plural, one {ඔබ දන්නා තවත් එකක්} other {# ඔබ දන්නා තවත්}}අනුගමනය කෙරේ.",
  "account.familiar_followers_one": "{name1}අනුගමනය කෙරේ",
  "account.familiar_followers_two": "පසුව {name1} සහ {name2}",
  "account.featured": "විශේෂාංග සහිත",
  "account.featured.accounts": "පැතිකඩ",
  "account.follow": "අනුගමනය",
  "account.follow_back": "ආපසු අනුගමනය කරන්න",
  "account.followers": "අනුගාමිකයින්",
  "account.followers.empty": "කිසිවෙක් අනුගමනය කර නැත.",
  "account.followers_counter": "{count, plural, one {{counter} අනුගාමිකයා} other {{counter} අනුගාමිකයින්}}",
  "account.following": "අනුගමන",
  "account.following_counter": "{count, plural, one {{counter} අනුගමනය කරනවා} other {{counter} අනුගමනය කරනවා}}",
  "account.follows.empty": "තවමත් කිසිවෙක් අනුගමනය නොකරයි.",
  "account.follows_you": "ඔබව අනුගමනය කරයි",
  "account.go_to_profile": "පැතිකඩට යන්න",
  "account.hide_reblogs": "@{name}වෙතින් බූස්ට් සඟවන්න",
  "account.in_memoriam": "මතකයේ.",
  "account.joined_short": "එක් වූ දිනය",
  "account.languages": "දායක වූ භාෂා වෙනස් කරන්න",
  "account.link_verified_on": "මෙම සබැඳියේ අයිතිය {date} දී පරීක්‍ෂා කෙරිණි",
  "account.locked_info": "මෙම ගිණුමේ රහස්‍යතා තත්ත්වය අගුළු දමා ඇත. හිමිකරු ඔවුන් අනුගමනය කළ හැක්කේ කාටද යන්න හස්තීයව සමාලෝචනය කරයි.",
  "account.media": "මාධ්‍ය",
  "account.mention": "@{name} සඳහන් කරන්ක",
  "account.moved_to": "{name} ඔවුන්ගේ නව ගිණුම දැන්:",
  "account.mute": "@{name} නිහඬ කරන්න",
  "account.mute_notifications_short": "දැනුම්දීම් නිහඬ කරන්න",
  "account.mute_short": "නිහඬ",
  "account.muted": "නිහඬ කළා",
  "account.mutual": "ඔබ එකිනෙකා අනුගමනය කරන්න.",
  "account.no_bio": "විස්තරයක් සපයා නැත.",
  "account.open_original_page": "මුල් පිටුව අරින්න",
  "account.posts": "ලිපි",
  "account.remove_from_followers": "අනුගාමිකයින්ගෙන් {name} ඉවත් කරන්න",
  "account.report": "@{name} වාර්තා කරන්න",
  "account.requested_follow": "{name} ඔබව අනුගමනය කිරීමට ඉල්ලා ඇත.",
  "account.share": "@{name} ගේ පැතිකඩ බෙදාගන්න",
  "account.show_reblogs": "@{name}වෙතින් බූස්ට් පෙන්වන්න",
  "account.statuses_counter": "{count, plural, one {{counter} සටහන} other {{counter} සටහන්}}",
  "account.unblock": "@{name} අනවහිර කරන්න",
  "account.unblock_domain": "{domain} වසම අනවහිර කරන්න",
  "account.unblock_domain_short": "අවහිර කිරීම ඉවත් කරන්න",
  "account.unblock_short": "අනවහිර",
  "account.unendorse": "පැතිකඩෙහි විශේෂාංග නොකරන්න",
  "account.unfollow": "අනුගමනය නොකරන්න",
  "account.unmute": "නිහඬ නොකරන්න @{name}",
  "account.unmute_notifications_short": "දැනුම්දීම් නිහඬ නොකරන්න",
  "account.unmute_short": "නොනිහඬ",
  "account_note.placeholder": "සටහන යෙදීමට ඔබන්න",
  "admin.dashboard.daily_retention": "ලියාපදිංචි වීමෙන් පසු දිනෙන් දින පරිශීලක රඳවා ගැනීමේ අනුපාතය",
  "admin.dashboard.monthly_retention": "ලියාපදිංචි වීමෙන් පසු මාසය අනුව පරිශීලක රඳවා ගැනීමේ අනුපාතය",
  "admin.dashboard.retention.average": "සාමාන්‍යය",
  "admin.dashboard.retention.cohort": "ලියාපදිංචි මාසය",
  "admin.dashboard.retention.cohort_size": "නව පරිශ්‍රීලකයින්",
  "admin.impact_report.instance_accounts": "මෙය මකා දමන ගිණුම් පැතිකඩ",
  "admin.impact_report.instance_followers": "අපගේ පරිශීලකයින්ට අහිමි වන අනුගාමිකයින්",
  "admin.impact_report.instance_follows": "ඔවුන්ගේ පරිශීලකයින්ට අහිමි වන අනුගාමිකයින්",
  "admin.impact_report.title": "බලපෑම් සාරාංශය",
  "alert.rate_limited.message": "{retry_time, time, medium} කට පසුව උත්සාහ කරන්න.",
  "alert.rate_limited.title": "අනුපාතනය වී ඇත",
  "alert.unexpected.message": "අනපේක්‍ෂිත දෝෂයක් සිදු විය.",
  "alert.unexpected.title": "අපොයි!",
  "alt_text_badge.title": "විකල්ප පෙළ",
  "alt_text_modal.add_alt_text": "විකල්ප පෙළ එක් කරන්න",
  "alt_text_modal.add_text_from_image": "රූපයෙන් පෙළ එක් කරන්න",
  "alt_text_modal.cancel": "අවලංගු කරන්න",
  "alt_text_modal.change_thumbnail": "සිඟිති රුව වෙනස් කරන්න",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "ශ්‍රවණාබාධ ඇති පුද්ගලයින් සඳහා මෙය විස්තර කරන්න…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "දෘශ්‍යාබාධිත පුද්ගලයින් සඳහා මෙය විස්තර කරන්න…",
  "alt_text_modal.done": "කළා",
  "announcement.announcement": "නිවේදනය",
  "annual_report.summary.most_used_app.most_used_app": "වැඩිපුරම භාවිතා කරන යෙදුම",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "වැඩිපුරම භාවිතා කරන ලද හැෂ් ටැගය",
  "annual_report.summary.new_posts.new_posts": "නව පළ කිරීම්",
  "annual_report.summary.percentile.text": "<topLabel>එය ඔබව {domain} පරිශීලකයින්ගෙන් ඉහළම</topLabel><percentage></percentage><bottomLabel>අතරට ගෙන එයි.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "අපි බර්නිට කියන්නේ නැහැ.",
  "attachments_list.unprocessed": "(සකසා නැති)",
  "audio.hide": "හඬපටය සඟවන්න",
  "block_modal.remote_users_caveat": "ඔබගේ තීරණයට ගරු කරන ලෙස අපි සේවාදායකයාගෙන් {domain} ඉල්ලා සිටිමු. කෙසේ වෙතත්, සමහර සේවාදායකයන් අවහිර කිරීම් වෙනස් ලෙස හසුරුවන බැවින් අනුකූලතාව සහතික නොවේ. පොදු පළ කිරීම් තවමත් ලොග් වී නොමැති පරිශීලකයින්ට දෘශ්‍යමාන විය හැකිය.",
  "block_modal.show_less": "අඩුවෙන් පෙන්වන්න",
  "block_modal.show_more": "තව පෙන්වන්න",
  "block_modal.they_will_know": "අවහිර කළ බව දකිනු ඇත.",
  "block_modal.title": "අවහිර කරන්නද?",
  "boost_modal.combo": "ඊළඟ වතාවේ මෙය මඟ හැරීමට {combo} එබීමට හැකිය",
  "boost_modal.reblog": "පළ කිරීම වැඩි කරන්නද?",
  "boost_modal.undo_reblog": "පළ කිරීම බූස්ට් නොකරන්නද?",
  "bundle_column_error.copy_stacktrace": "දෝෂ වාර්තාවේ පිටපතක්",
  "bundle_column_error.error.body": "ඉල්ලූ පිටුව විදැහුම් කළ නොහැකි විය. එය අපගේ කේතයේ දෝෂයක් හෝ බ්‍රව්සර් අනුකූලතා ගැටලුවක් නිසා විය හැකිය.",
  "bundle_column_error.error.title": "අපොයි!",
  "bundle_column_error.network.body": "මෙම පිටුව පූරණය කිරීමට උත්සාහ කිරීමේදී දෝෂයක් ඇති විය. මෙය ඔබගේ අන්තර්ජාල සම්බන්ධතාවයේ හෝ මෙම සේවාදායකයේ තාවකාලික ගැටළුවක් නිසා විය හැකිය.",
  "bundle_column_error.network.title": "ජාලයේ දෝෂයකි",
  "bundle_column_error.retry": "නැවත උත්සාහ කරන්න",
  "bundle_column_error.return": "ආපසු මුලට යන්න",
  "bundle_column_error.routing.body": "ඉල්ලූ පිටුව සොයාගත නොහැකි විය. ලිපින තීරුවේ ඇති URL එක නිවැරදි බව ඔබට විශ්වාසද?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "වසන්න",
  "bundle_modal_error.message": "මෙම තිරය පූරණය කිරීමේදී යමක් වැරදී ඇත.",
  "bundle_modal_error.retry": "නැවත උත්සාහ කරන්න",
  "closed_registrations.other_server_instructions": "Mastodon විමධ්‍යගත කර ඇති බැවින්, ඔබට වෙනත් සේවාදායකයක ගිණුමක් සාදා මෙම සේවාදායකය සමඟ අන්තර් ක්‍රියා කළ හැකිය.",
  "closed_registrations_modal.description": "{domain} හි ගිණුමක් නිර්මාණය කිරීම දැනට කළ නොහැකි නමුත්, Mastodon භාවිතා කිරීමට ඔබට {domain} හි නිශ්චිත ගිණුමක් අවශ්‍ය නොවන බව කරුණාවෙන් සලකන්න.",
  "closed_registrations_modal.find_another_server": "වෙනත් සේවාදායක",
  "closed_registrations_modal.preamble": "Mastodon විමධ්‍යගත කර ඇත, එබැවින් ඔබ ඔබේ ගිණුම කොතැනක නිර්මාණය කළත්, ඔබට මෙම සේවාදායකයේ ඕනෑම අයෙකු අනුගමනය කිරීමට සහ අන්තර් ක්‍රියා කිරීමට හැකි වනු ඇත. ඔබට එය ස්වයං-සත්කාරක කිරීමට පවා හැකිය!",
  "closed_registrations_modal.title": "මාස්ටඩන් හි ලියාපදිංචි වන්න",
  "column.about": "පිලිබඳව",
  "column.blocks": "අවහිර කළ අය",
  "column.bookmarks": "පොත්යොමු",
  "column.community": "ස්ථානීය කාලරේඛාව",
  "column.create_list": "ලැයිස්තුවක් සාදන්න",
  "column.direct": "පෞද්ගලික සැඳහුම්",
  "column.directory": "පැතිකඩ පිරික්සන්න",
  "column.domain_blocks": "අවහිර කළ වසම්",
  "column.edit_list": "ලැයිස්තුව සංස්කරණය කරන්න",
  "column.favourites": "ප්‍රියතමයන්",
  "column.firehose": "සජීව සංග්‍රහ",
  "column.follow_requests": "අනුගමන ඉල්ලීම්",
  "column.home": "මුල් පිටුව",
  "column.list_members": "ලැයිස්තු සාමාජිකයන් කළමනාකරණය කරන්න",
  "column.lists": "ලැයිස්තු",
  "column.mutes": "නිහඬ කළ අය",
  "column.notifications": "දැනුම්දීම්",
  "column.pins": "ඇමිණූ ලිපි",
  "column.public": "ඒකාබද්ධ කාලරේඛාව",
  "column_back_button.label": "ආපසු",
  "column_header.hide_settings": "සැකසුම් සඟවන්න",
  "column_header.moveLeft_settings": "තීරුව වමට ගෙනයන්න",
  "column_header.moveRight_settings": "තීරුව දකුණට ගෙනයන්න",
  "column_header.pin": "අමුණන්න",
  "column_header.show_settings": "සැකසුම් පෙන්වන්න",
  "column_header.unpin": "ගළවන්න",
  "column_search.cancel": "අවලංගු කරන්න",
  "community.column_settings.local_only": "ස්ථානීයව පමණයි",
  "community.column_settings.media_only": "මාධ්‍ය පමණයි",
  "community.column_settings.remote_only": "දුරස්ථව පමණයි",
  "compose.language.change": "භාෂාව සංශෝධනය",
  "compose.language.search": "භාෂා සොයන්න...",
  "compose.published.body": "ලිපිය පළ විය.",
  "compose.published.open": "අරින්න",
  "compose.saved.body": "ලිපිය සුරැකිණි.",
  "compose_form.direct_message_warning_learn_more": "තව දැනගන්න",
  "compose_form.encryption_warning": "මාස්ටඩන් වෙත පළ කරන දෑ අන්ත සංකේතනයෙන් ආරක්‍ෂා නොවේ. මාස්ටඩන් හරහා කිසිදු සංවේදී තොරතුරක් බෙදා නොගන්න.",
  "compose_form.hashtag_warning": "මෙම සටහන පොදු නොවන බැවින් කිසිදු හැෂ් ටැග් එකක් යටතේ ලැයිස්තුගත නොකෙරේ. හැෂ් ටැග් භාවිතයෙන් සෙවිය හැක්කේ පොදු පළ කිරීම් පමණි.",
  "compose_form.lock_disclaimer": "ඔබේ ගිණුම {locked}නොවේ. ඕනෑම කෙනෙකුට ඔබේ අනුගාමිකයින්ට පමණක් වන සටහන් බැලීමට ඔබව අනුගමනය කළ හැක.",
  "compose_form.lock_disclaimer.lock": "අගුළු දමා ඇත",
  "compose_form.placeholder": "ඔබගේ සිතුවිලි මොනවාද?",
  "compose_form.poll.duration": "මත විමසීමේ කාලය",
  "compose_form.poll.multiple": "බහුවරණ",
  "compose_form.poll.option_placeholder": "විකල්පය {number}",
  "compose_form.poll.single": "තනි තේරීම",
  "compose_form.poll.switch_to_multiple": "තේරීම් කිහිපයකට මත විමසුම වෙනස් කරන්න",
  "compose_form.poll.switch_to_single": "තනි තේරීමකට මත විමසුම වෙනස් කරන්න",
  "compose_form.poll.type": "ශෛලිය",
  "compose_form.publish": "ප්‍රකාශනය",
  "compose_form.reply": "පිළිතුරු",
  "compose_form.save_changes": "යාවත්කාලීන කරන්න",
  "compose_form.spoiler.marked": "අන්තර්ගත අවවාදය ඉවත් කරන්න",
  "compose_form.spoiler.unmarked": "අන්තර්ගත අවවාදයක් එක් කරන්න",
  "compose_form.spoiler_placeholder": "අන්තර්ගත අනතුරු ඇඟවීම (විකල්ප)",
  "confirmation_modal.cancel": "අවලංගු",
  "confirmations.block.confirm": "අවහිර",
  "confirmations.delete.confirm": "මකන්න",
  "confirmations.delete.message": "ඔබට මෙම ලිපිය මැකීමට වුවමනා ද?",
  "confirmations.delete.title": "පළ කිරීම මකන්නද?",
  "confirmations.delete_list.confirm": "මකන්න",
  "confirmations.delete_list.message": "ඔබට මෙම ලැයිස්තුව සදහටම මැකීමට වුවමනා ද?",
  "confirmations.delete_list.title": "ලැයිස්තුව මකන්නද?",
  "confirmations.discard_edit_media.confirm": "ඉවත ලන්න",
  "confirmations.discard_edit_media.message": "ඔබට මාධ්‍ය විස්තරයට හෝ පෙරදසුනට නොසුරකින ලද වෙනස්කම් තිබේ, කෙසේ වෙතත් ඒවා ඉවත දමන්නද?",
  "confirmations.follow_to_list.confirm": "අනුගමනය කර ලැයිස්තුවට එක් කරන්න",
  "confirmations.follow_to_list.message": "ඒවා ලැයිස්තුවකට එකතු කිරීමට ඔබ {name} අනුගමනය කළ යුතුය.",
  "confirmations.follow_to_list.title": "පරිශීලකයා අනුගමනය කරන්නද?",
  "confirmations.logout.confirm": "නික්මෙන්න",
  "confirmations.logout.message": "ඔබට නික්මෙන්න අවශ්‍ය බව විශ්වාසද?",
  "confirmations.logout.title": "ඉවත් වන්නද?",
  "confirmations.missing_alt_text.confirm": "විකල්ප පෙළ එක් කරන්න",
  "confirmations.missing_alt_text.message": "ඔබගේ සටහනේ විකල්ප පෙළ නොමැතිව මාධ්‍ය අඩංගු වේ. විස්තර එකතු කිරීම ඔබේ අන්තර්ගතයට වැඩි පිරිසකට ප්‍රවේශ විය හැකි කිරීමට උපකාරී වේ.",
  "confirmations.missing_alt_text.secondary": "කෙසේ වෙතත් පළ කරන්න",
  "confirmations.missing_alt_text.title": "විකල්ප පෙළ එක් කරන්නද?",
  "confirmations.mute.confirm": "නිශ්ශබ්ද",
  "confirmations.redraft.confirm": "& නැවත කෙටුම්පත මකන්න",
  "confirmations.redraft.message": "ඔබට මෙම පළ කිරීම මකා දමා නැවත කෙටුම්පත් කිරීමට අවශ්‍ය බව ඔබට විශ්වාසද? ප්‍රියතමයන් සහ වැඩි කිරීම් අහිමි වනු ඇති අතර, මුල් පළ කිරීමට පිළිතුරු අනාථ වනු ඇත.",
  "confirmations.redraft.title": "& නැවත කෙටුම්පත් කළ පළ කිරීම මකන්නද?",
  "confirmations.remove_from_followers.confirm": "අනුගාමිකයා ඉවත් කරන්න",
  "confirmations.remove_from_followers.message": "{name} ඔබව අනුගමනය කිරීම නවත්වනු ඇත. ඔබට ඉදිරියට යාමට අවශ්‍ය බව විශ්වාසද?",
  "confirmations.remove_from_followers.title": "අනුගාමිකයා ඉවත් කරන්නද?",
  "confirmations.unfollow.confirm": "අනුගමනය නොකරන්න",
  "content_warning.hide": "සටහන සඟවන්න",
  "content_warning.show": "කෙසේ වෙතත් පෙන්වන්න",
  "content_warning.show_more": "තවත් පෙන්වන්න",
  "conversation.delete": "සංවාදය මකන්න",
  "conversation.mark_as_read": "කියවූ බව යොදන්න",
  "conversation.open": "සංවාදය බලන්න",
  "conversation.with": "{names} සමඟ",
  "copy_icon_button.copied": "පසුරුපුවරුවට පිටපත් විය",
  "copypaste.copied": "පිටපත් විය",
  "copypaste.copy_to_clipboard": "පසුරුපුවරුවට පිටපතක්",
  "directory.federated": "දන්නා ෆෙඩිවර්ස් වෙතින්",
  "directory.local": "{domain} වෙතින් පමණි",
  "directory.new_arrivals": "නව පැමිණීම්",
  "directory.recently_active": "මෑත දී සක්‍රියයි",
  "disabled_account_banner.account_settings": "ගිණුමේ සැකසුම්",
  "disabled_account_banner.text": "ඔබගේ {disabledAccount} ගිණුම දැනට අක්‍රිය කර ඇත.",
  "dismissable_banner.community_timeline": "මේවා {domain}විසින් සත්කාරකත්වය දරන ගිණුම් ඇති පුද්ගලයින්ගේ නවතම පොදු සටහන් වේ.",
  "dismissable_banner.dismiss": "ඉවතලන්න",
  "dismissable_banner.public_timeline": "මේවා {domain} හි පුද්ගලයින් අනුගමනය කරන fediverse හි පුද්ගලයින්ගේ නවතම ප්‍රසිද්ධ සටහන් වේ.",
  "domain_block_modal.block": "සේවාදායකය අවහිර කරන්න",
  "domain_block_modal.block_account_instead": "ඒ වෙනුවට @{name} අවහිර කරන්න",
  "domain_block_modal.they_can_interact_with_old_posts": "මෙම සේවාදායකයේ පුද්ගලයින්ට ඔබගේ පැරණි සටහන් සමඟ අන්තර් ක්‍රියා කළ හැක.",
  "domain_block_modal.they_cant_follow": "මෙම සේවාදායකයෙන් කිසිවෙකුට ඔබව අනුගමනය කළ නොහැක.",
  "domain_block_modal.they_wont_know": "ඔවුන් අවහිර කර ඇති බව ඔවුන් නොදනී.",
  "domain_block_modal.title": "වසම අවහිර කරන්නද?",
  "domain_block_modal.you_will_lose_num_followers": "ඔබ {followersCount, plural, one {{followersCountDisplay} අනුගාමිකයා} other {{followersCountDisplay} අනුගාමිකයින්}} සහ {followingCount, plural, one {{followingCountDisplay} ඔබ අනුගමනය කරන පුද්ගලයා} other {{followingCountDisplay} ඔබ අනුගමනය කරන පුද්ගලයින්}}අහිමි වනු ඇත.",
  "domain_block_modal.you_will_lose_relationships": "මෙම සේවාදායකයෙන් ඔබ අනුගමනය කරන සියලුම අනුගාමිකයින් සහ පුද්ගලයින් ඔබට අහිමි වනු ඇත.",
  "domain_block_modal.you_wont_see_posts": "මෙම සේවාදායකයේ පරිශීලකයින්ගෙන් ඔබට සටහන් හෝ දැනුම්දීම් නොපෙනේ.",
  "domain_pill.activitypub_lets_connect": "එය ඔබට Mastodon හි පමණක් නොව, විවිධ සමාජ යෙදුම් හරහාද පුද්ගලයින් සමඟ සම්බන්ධ වීමට සහ අන්තර් ක්‍රියා කිරීමට ඉඩ සලසයි.",
  "domain_pill.activitypub_like_language": "ActivityPub යනු Mastodon අනෙකුත් සමාජ ජාල සමඟ කතා කරන භාෂාවට සමානය.",
  "domain_pill.server": "සේවාදායකය",
  "domain_pill.their_handle": "ඔවුන්ගේ හසුරුව:",
  "domain_pill.their_server": "ඔවුන්ගේ සියලුම සටහන් අඩංගු ඩිජිටල් නිවස.",
  "domain_pill.their_username": "ඔවුන්ගේ සේවාදායකයේ ඔවුන්ගේ අනන්‍ය හඳුනාගැනීමේ යන්ත්‍රය. විවිධ සේවාදායකයන්හි එකම පරිශීලක නාමයක් ඇති පරිශීලකයින් සොයා ගැනීමට හැකිය.",
  "domain_pill.username": "පරිශ්‍රීලක නාමය",
  "domain_pill.whats_in_a_handle": "හසුරුවක ඇත්තේ කුමක්ද?",
  "domain_pill.who_they_are": "හැන්ඩ්ල් මඟින් කෙනෙකු කවුද සහ ඔවුන් සිටින්නේ කොහේද යන්න පවසන බැවින්, ඔබට <button>ActivityPub-බලගැන්වූ වේදිකා</button>හි සමාජ වෙබ් අඩවි හරහා පුද්ගලයින් සමඟ අන්තර් ක්‍රියා කළ හැකිය.",
  "domain_pill.who_you_are": "ඔබේ හැන්ඩ්ල් එක ඔබ කවුද සහ ඔබ සිටින ස්ථානය පවසන නිසා, <button>ActivityPub-බලගැන්වූ වේදිකා</button>හි සමාජ වෙබ් අඩවි හරහා පුද්ගලයින්ට ඔබ සමඟ අන්තර් ක්‍රියා කළ හැකිය.",
  "domain_pill.your_handle": "ඔබේ හසුරුව:",
  "domain_pill.your_server": "ඔබේ සියලුම සටහන් තිබෙන ඔබේ ඩිජිටල් නිවස. මේකට කැමති නැද්ද? ඕනෑම වේලාවක සේවාදායක මාරු කර ඔබේ අනුගාමිකයින් ද රැගෙන එන්න.",
  "domain_pill.your_username": "මෙම සේවාදායකයේ ඔබගේ අනන්‍ය හඳුනාගැනීමේ අංකය. විවිධ සේවාදායකයන්හි එකම පරිශීලක නාමය ඇති පරිශීලකයින් සොයා ගැනීමට හැකිය.",
  "embed.instructions": "පහත කේතය පිටපත් කිරීමෙන් මෙම ලිපිය ඔබගේ අඩවියට කාවද්දන්න.",
  "embed.preview": "මෙන්න එය පෙනෙන අන්දම:",
  "emoji_button.activity": "ක්‍රියාකාරකම",
  "emoji_button.clear": "මකන්න",
  "emoji_button.custom": "අභිරුචි",
  "emoji_button.flags": "කොඩි",
  "emoji_button.food": "ආහාර සහ පාන",
  "emoji_button.label": "ඉමොජි යොදන්න",
  "emoji_button.nature": "සොබාදහම",
  "emoji_button.not_found": "ගැළපෙන ඉමෝජි හමු නොවිණි",
  "emoji_button.objects": "වස්තූන්",
  "emoji_button.people": "මිනිසුන්",
  "emoji_button.recent": "නිතර භාවිතා වූ",
  "emoji_button.search": "සොයන්න...",
  "emoji_button.search_results": "සෙවුම් ප්‍රතිඵල",
  "emoji_button.symbols": "සංකේත",
  "emoji_button.travel": "චාරිකා සහ ස්ථාන",
  "empty_column.account_hides_collections": "මෙම පරිශීලකයා මෙම තොරතුරු ලබා ගත නොහැකි ලෙස සකස් කර ඇත.",
  "empty_column.account_suspended": "ගිණුම අත්හිටුවා ඇත",
  "empty_column.account_timeline": "මෙහි ලිපි නැත!",
  "empty_column.account_unavailable": "පැතිකඩ නොතිබේ",
  "empty_column.blocks": "කිසිදු පරිශීලකයෙකු අවහිර කර නැත.",
  "empty_column.bookmarked_statuses": "ඔබ සතුව පොත්යොමු තබන ලද ලිපි කිසිවක් නැත. ඔබ පොත්යොමුවක් තබන විට, එය මෙහි දිස්වනු ඇත.",
  "empty_column.community": "දේශීය කාලරේඛාව හිස්. පන්දුව පෙරළීමට ප්‍රසිද්ධියේ යමක් ලියන්න!",
  "empty_column.direct": "ඔබට තවම කිසිදු පෞද්ගලික සඳහන් කිරීමක් නොමැත. ඔබ එකක් යවන විට හෝ ලැබෙන විට, එය මෙහි පෙන්වනු ඇත.",
  "empty_column.domain_blocks": "අවහිර කරන ලද වසම් නැත.",
  "empty_column.explore_statuses": "දැන් කිසිවක් නැඹුරු නොවේ. පසුව නැවත පරීක්ෂා කරන්න!",
  "empty_column.favourited_statuses": "ඔබ සතුව ප්‍රියතම ලිපි කිසිවක් නැත. ඔබ යමකට ප්‍රිය කළ විට එය මෙහි පෙන්වනු ඇත.",
  "empty_column.favourites": "මෙම සටහනට තවමත් කිසිවෙකු ප්‍රියතම එකක් දමා නැත. යමෙකු එසේ කළ විට, ඔවුන් මෙහි පෙන්වනු ඇත.",
  "empty_column.follow_requests": "ඔබට තවමත් අනුගමන ඉල්ලීම් ලැබී නැත. ඉල්ලීමක් ලැබුණු විට, එය මෙහි පෙන්වනු ඇත.",
  "empty_column.followed_tags": "ඔබ තවමත් කිසිදු හැෂ් ටැගයක් අනුගමනය කර නැත. ඔබ එසේ කළ විට, ඒවා මෙහි පෙන්වනු ඇත.",
  "empty_column.hashtag": "මෙම හැෂ් ටැගයේ තවමත් කිසිවක් නොමැත.",
  "empty_column.home": "මුල් පිටුව හිස් ය! මෙය පිරවීමට බොහෝ පුද්ගලයින් අනුගමනය කරන්න.",
  "empty_column.list": "මෙම ලැයිස්තුවේ තවමත් කිසිවක් නොමැත. මෙම ලැයිස්තුවේ සාමාජිකයින් නව සටහන් ප්‍රකාශයට පත් කරන විට, ඒවා මෙහි දිස්වනු ඇත.",
  "empty_column.mutes": "ඔබ තවමත් කිසිදු පරිශීලකයෙකු නිහඬ කර නැත.",
  "empty_column.notification_requests": "සියල්ල පැහැදිලියි! මෙහි කිසිවක් නැත. ඔබට නව දැනුම්දීම් ලැබුණු විට, ඒවා ඔබගේ සැකසුම් අනුව මෙහි දිස්වනු ඇත.",
  "empty_column.notifications": "ඔබට දැනුම්දීම් ලැබී නැත. අන් අය සහ ඔබ අතර අන්‍යෝන්‍ය බලපවත්වන දෑ මෙහි දිස්වනු ඇත.",
  "empty_column.public": "මෙහි කිසිවක් නැත! ප්‍රසිද්ධියේ යමක් ලියන්න, නැතහොත් එය පිරවීම සඳහා වෙනත් සේවාදායකයන්ගෙන් පරිශීලකයින් අතින් අනුගමනය කරන්න.",
  "error.unexpected_crash.explanation": "අපගේ කේතයේ දෝෂයක් හෝ බ්‍රවුසර ගැළපුම් ගැටලුවක් හේතුවෙන්, මෙම පිටුව නිවැරදිව ප්‍රදර්ශනය කළ නොහැක.",
  "error.unexpected_crash.explanation_addons": "මෙම පිටුව නිවැරදිව ප්‍රදර්ශනය කළ නොහැක. මෙම දෝෂය බ්‍රවුසර ඇඩෝනයක් හෝ ස්වයංක්‍රීය පරිවර්තන මෙවලම් නිසා ඇති විය හැක.",
  "error.unexpected_crash.next_steps": "පිටුව නැවුම් කර බලන්න. එයින් ඵලක් නොවේ නම්, වෙනත් අතිරික්සුවක් හෝ නිසග යෙදුමක් හරහා මාස්ටඩන් භාවිතා කරන්න.",
  "error.unexpected_crash.next_steps_addons": "ඒවා අබල කර පිටුව නැවුම් කරන්න. එයින් ඵලක් නොවේ නම්, වෙනත් අතිරික්සුවක් හෝ නිසග යෙදුමක් හරහා මාස්ටඩන් භාවිතා කරන්න.",
  "errors.unexpected_crash.copy_stacktrace": "stacktrace පසුරු පුවරුවට පිටපත් කරන්න",
  "errors.unexpected_crash.report_issue": "ගැටළුව වාර්තාව",
  "explore.suggested_follows": "පුද්ගලයින්",
  "explore.trending_links": "පුවත්",
  "explore.trending_statuses": "ලිපි",
  "explore.trending_tags": "හැෂ් ටැග්",
  "filter_modal.added.context_mismatch_explanation": "මෙම පෙරහන් කාණ්ඩය ඔබ මෙම සටහනට ප්‍රවේශ වූ සන්දර්භයට අදාළ නොවේ. මෙම සන්දර්භය තුළද සටහන පෙරහන් කිරීමට ඔබට අවශ්‍ය නම්, ඔබට පෙරහන සංස්කරණය කිරීමට සිදුවේ.",
  "filter_modal.added.context_mismatch_title": "සන්දර්භය නොගැලපීම!",
  "filter_modal.added.expired_explanation": "මෙම පෙරහන් කාණ්ඩය කල් ඉකුත් වී ඇත, එය යෙදීම සඳහා ඔබට කල් ඉකුත් වීමේ දිනය වෙනස් කිරීමට අවශ්‍ය වනු ඇත.",
  "filter_modal.added.expired_title": "පෙරහන ඉකුත්ය!",
  "filter_modal.added.review_and_configure": "මෙම පෙරහන් කාණ්ඩය සමාලෝචනය කිරීමට සහ තවදුරටත් වින්‍යාස කිරීමට, {settings_link}වෙත යන්න.",
  "filter_modal.added.review_and_configure_title": "පෙරහන් සැකසුම්",
  "filter_modal.added.settings_link": "සැකසුම් පිටුව",
  "filter_modal.added.short_explanation": "මෙම සටහන පහත පෙරහන් කාණ්ඩයට එක් කර ඇත: {title}.",
  "filter_modal.added.title": "පෙරහන එක් කළා!",
  "filter_modal.select_filter.context_mismatch": "මෙම සන්දර්භයට අදාළ නොවේ.",
  "filter_modal.select_filter.expired": "ඉකුත්ය",
  "filter_modal.select_filter.prompt_new": "නව ප්‍රවර්ගය: {name}",
  "filter_modal.select_filter.search": "සොයන්න හෝ සාදන්න",
  "filter_modal.select_filter.subtitle": "පවතින ප්‍රවර්ගයක් භාවිතා කරන්න හෝ අලුත් එකක් සාදන්න",
  "filter_modal.select_filter.title": "මෙම ලිපිය පෙරන්න",
  "filter_modal.title.status": "ලිපියක් පෙරන්න",
  "filter_warning.matches_filter": "ගැලපීම් පෙරහන “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "{count, plural, =0 {කිසිවෙකුගෙන්} one {එක් පුද්ගලයෙකුගෙන්} other {# පුද්ගලයින්}} ඔබ දන්නවා ඇති",
  "filtered_notifications_banner.title": "පෙරූ දැනුම්දීම්",
  "firehose.all": "සියල්ල",
  "firehose.local": "මෙම සේවාදායකය",
  "firehose.remote": "වෙනත් සේවාදායක",
  "follow_request.authorize": "අවසර දෙන්න",
  "follow_request.reject": "ප්‍රතික්‍ෂේප",
  "follow_requests.unlocked_explanation": "ඔබගේ ගිණුම අගුළු දමා නොමැති වුවද, {domain} කාර්ය මණ්ඩලය සිතුවේ ඔබට මෙම ගිණුම් වලින් ලැබෙන අනුගමන ඉල්ලීම් අතින් සමාලෝචනය කිරීමට අවශ්‍ය විය හැකි බවයි.",
  "follow_suggestions.curated_suggestion": "කාර්ය මණ්ඩල තේරීම",
  "follow_suggestions.dismiss": "නැවත පෙන්වන්න එපා",
  "follow_suggestions.featured_longer": "{domain} කණ්ඩායම විසින් අතින් තෝරා ගන්නා ලදී.",
  "follow_suggestions.friends_of_friends_longer": "ඔබ අනුගමනය කරන පුද්ගලයින් අතර ජනප්‍රිය",
  "follow_suggestions.hints.featured": "මෙම පැතිකඩ {domain} කණ්ඩායම විසින් අතින් තෝරාගෙන ඇත.",
  "follow_suggestions.hints.friends_of_friends": "මෙම පැතිකඩ ඔබ අනුගමනය කරන පුද්ගලයින් අතර ජනප්‍රියයි.",
  "follow_suggestions.hints.most_followed": "මෙම පැතිකඩ {domain}හි වැඩිපුරම අනුගමනය කරන ලද එකකි.",
  "follow_suggestions.hints.most_interactions": "මෙම පැතිකඩ මෑතකදී {domain}හි විශාල අවධානයක් ලබා ගනිමින් පවතී.",
  "follow_suggestions.hints.similar_to_recently_followed": "මෙම පැතිකඩ ඔබ මෑතකදී අනුගමනය කළ පැතිකඩවලට සමානය.",
  "follow_suggestions.personalized_suggestion": "පුද්ගලාරෝපිත යෝජනාව",
  "follow_suggestions.popular_suggestion": "ජනප්‍රිය යෝජනාව",
  "follow_suggestions.popular_suggestion_longer": "{domain}හි ජනප්‍රියයි",
  "follow_suggestions.similar_to_recently_followed_longer": "ඔබ මෑතකදී අනුගමනය කළ පැතිකඩවලට සමානයි",
  "follow_suggestions.view_all": "සියල්ල බලන්න",
  "follow_suggestions.who_to_follow": "කාවද අනුගමනය කරන්න ඕනේ",
  "followed_tags": "අනුගමනය කළ හැෂ් ටැග්",
  "footer.about": "පිළිබඳව",
  "footer.directory": "පැතිකඩ නාමාවලිය",
  "footer.get_app": "යෙදුම ගන්න",
  "footer.keyboard_shortcuts": "යතුරුපුවරුවේ කෙටිමං",
  "footer.privacy_policy": "රහස්‍යතා ප්‍රතිපත්තිය",
  "footer.source_code": "මූලාශ්‍ර කේතය බලන්න",
  "footer.status": "තත්‍වය",
  "footer.terms_of_service": "සේවා කොන්දේසි",
  "generic.saved": "සුරැකිණි",
  "getting_started.heading": "පටන් ගන්න",
  "hashtag.admin_moderation": "#{name}සඳහා මධ්‍යස්ථකරණ අතුරුමුහුණත විවෘත කරන්න",
  "hashtag.browse": "#{hashtag}හි සටහන් පිරික්සන්න",
  "hashtag.browse_from_account": "#{hashtag}හි @{name} සිට සටහන් බ්‍රවුස් කරන්න",
  "hashtag.column_header.tag_mode.all": "සහ {additional}",
  "hashtag.column_header.tag_mode.any": "හෝ {additional}",
  "hashtag.column_header.tag_mode.none": "{additional}නොමැතිව",
  "hashtag.column_settings.select.no_options_message": "යෝජනා හමු නොවිණි",
  "hashtag.column_settings.select.placeholder": "…හැෂ් ටැග් ඇතුළත් කරන්න",
  "hashtag.column_settings.tag_mode.all": "මේ සියල්ලම",
  "hashtag.column_settings.tag_mode.any": "මේවායින් ඕනෑම එකක්",
  "hashtag.column_settings.tag_mode.none": "මේ කිසිවක් නැත",
  "hashtag.column_settings.tag_toggle": "මෙම තීරුවේ අමතර ටැග් ඇතුළත් කරන්න",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} සහභාගිවන්නන්} other {{counter} සහභාගිවන්නන්}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} සටහන} other {{counter} සටහන්}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} සටහන} other {{counter} සටහන්}} අද",
  "hashtag.feature": "පැතිකඩෙහි විශේෂාංගය",
  "hashtag.follow": "හැෂ් ටැගය අනුගමනය කරන්න",
  "hashtag.mute": "නිහඬ කරන්න #{hashtag}",
  "hashtag.unfeature": "පැතිකඩෙහි විශේෂාංගගත නොකරන්න.",
  "hashtag.unfollow": "හැෂ් ටැගය අනුගමනය නොකරන්න",
  "hashtags.and_other": "…සහ {count, plural, other {# තව}}",
  "hints.profiles.followers_may_be_missing": "මෙම පැතිකඩ සඳහා අනුගාමිකයින් අතුරුදහන් විය හැකිය.",
  "hints.profiles.follows_may_be_missing": "මෙම පැතිකඩ සඳහා අනුගාමිකයින් අතුරුදහන් විය හැකිය.",
  "hints.profiles.posts_may_be_missing": "මෙම පැතිකඩෙන් සමහර සටහන් අස්ථානගත වී තිබිය හැක.",
  "hints.profiles.see_more_followers": "{domain}හි තවත් අනුගාමිකයින් බලන්න",
  "hints.profiles.see_more_follows": "{domain}හි තවත් පහත ඒවා බලන්න.",
  "hints.profiles.see_more_posts": "{domain}හි තවත් සටහන් බලන්න",
  "home.column_settings.show_reblogs": "බූස්ට් පෙන්වන්න",
  "home.column_settings.show_replies": "පිළිතුරු පෙන්වන්න",
  "home.hide_announcements": "නිවේදන සඟවන්න",
  "home.pending_critical_update.body": "කරුණාකර හැකි ඉක්මනින් ඔබේ Mastodon සේවාදායකය යාවත්කාලීන කරන්න!",
  "home.pending_critical_update.link": "යාවත්කාල බලන්න",
  "home.pending_critical_update.title": "වැදගත් ආරක්ෂක යාවත්කාලීනයක් තිබේ!",
  "home.show_announcements": "නිවේදන පෙන්වන්න",
  "ignore_notifications_modal.disclaimer": "ඔබ ඔවුන්ගේ දැනුම්දීම් නොසලකා හැර ඇති බව Mastodon හට පරිශීලකයින්ට දැනුම් දිය නොහැක. දැනුම්දීම් නොසලකා හැරීමෙන් පණිවිඩ යැවීම නතර නොවේ.",
  "ignore_notifications_modal.filter_instead": "ඒ වෙනුවට පෙරහන් කරන්න",
  "ignore_notifications_modal.filter_to_act_users": "ඔබට තවමත් පරිශීලකයින් පිළිගැනීමට, ප්‍රතික්ෂේප කිරීමට හෝ වාර්තා කිරීමට හැකි වනු ඇත.",
  "ignore_notifications_modal.filter_to_avoid_confusion": "පෙරහන් කිරීම විය හැකි ව්‍යාකූලත්වය වළක්වා ගැනීමට උපකාරී වේ",
  "ignore_notifications_modal.filter_to_review_separately": "ඔබට පෙරහන් කළ දැනුම්දීම් වෙන වෙනම සමාලෝචනය කළ හැකිය.",
  "ignore_notifications_modal.ignore": "දැනුම්දීම් නොසලකා හරින්න",
  "ignore_notifications_modal.limited_accounts_title": "මධ්‍යස්ථ ගිණුම් වලින් ලැබෙන දැනුම්දීම් නොසලකා හරින්නද?",
  "ignore_notifications_modal.new_accounts_title": "නව ගිණුම් වලින් ලැබෙන දැනුම්දීම් නොසලකා හරින්නද?",
  "ignore_notifications_modal.not_followers_title": "ඔබව අනුගමනය නොකරන පුද්ගලයින්ගෙන් ලැබෙන දැනුම්දීම් නොසලකා හරින්නද?",
  "ignore_notifications_modal.not_following_title": "ඔබ අනුගමනය නොකරන පුද්ගලයින්ගෙන් ලැබෙන දැනුම්දීම් නොසලකා හරින්නද?",
  "ignore_notifications_modal.private_mentions_title": "අයාචිත පෞද්ගලික සඳහන් කිරීම් වලින් ලැබෙන දැනුම්දීම් නොසලකා හරින්නද?",
  "info_button.label": "උදව්",
  "info_button.what_is_alt_text": "<h1>alt පෙළ යනු කුමක්ද?</h1> <p>දෘශ්‍යාබාධිත, අඩු කලාප පළල සම්බන්ධතා ඇති පුද්ගලයින් හෝ අමතර සන්දර්භයක් සොයන අය සඳහා Alt පෙළ රූප විස්තර සපයයි.</p> <p>පැහැදිලි, සංක්ෂිප්ත සහ වෛෂයික alt පෙළ ලිවීමෙන් ඔබට සැමට ප්‍රවේශ්‍යතාව සහ අවබෝධය වැඩි දියුණු කළ හැකිය.</p> <ul> <li>වැදගත් අංග ග්‍රහණය කරගන්න</li> <li>රූපවල පෙළ සාරාංශ කරන්න</li> <li>නිත්‍ය වාක්‍ය ව්‍යුහය භාවිතා කරන්න</li> <li>අතිරික්ත තොරතුරු වලින් වළකින්න</li> <li>සංකීර්ණ දෘශ්‍යවල (රූප සටහන් හෝ සිතියම් වැනි) ප්‍රවණතා සහ ප්‍රධාන සොයාගැනීම් කෙරෙහි අවධානය යොමු කරන්න</li> </ul>",
  "interaction_modal.go": "යන්න",
  "interaction_modal.no_account_yet": "තවම ගිණුමක් නැද්ද?",
  "interaction_modal.on_another_server": "වෙනත් සේවාදායකයක",
  "interaction_modal.on_this_server": "මෙම සේවාදායකයෙහි",
  "interaction_modal.username_prompt": "උදා {example}",
  "intervals.full.days": "{number, plural, one {දවස් #} other {දවස් #}}",
  "intervals.full.hours": "{number, plural, one {පැය #} other {පැය #}}",
  "intervals.full.minutes": "{number, plural, one {විනාඩි #} other {විනාඩි #}}",
  "keyboard_shortcuts.back": "ආපසු යාත්‍රණය",
  "keyboard_shortcuts.blocked": "අවහිර කළ පරිශීලක ලැයිස්තුව විවෘත කරන්න",
  "keyboard_shortcuts.boost": "පළ කිරීම වැඩි කරන්න",
  "keyboard_shortcuts.column": "තීරුව අවධානය යොමු කරන්න",
  "keyboard_shortcuts.compose": "පෙළ ප්‍රදේශය රචනා කිරීමට අවධානය යොමු කරන්න",
  "keyboard_shortcuts.description": "සවිස්තරය",
  "keyboard_shortcuts.down": "ලැයිස්තුවේ පහළට ගෙනයන්න",
  "keyboard_shortcuts.enter": "ලිපිය අරින්න",
  "keyboard_shortcuts.favourite": "ප්‍රියතම පළ කිරීම",
  "keyboard_shortcuts.favourites": "ප්‍රියතමයන් ලැයිස්තුව අරින්න",
  "keyboard_shortcuts.federated": "ෆෙඩරේටඩ් කාලරාමුව විවෘත කිරීමට",
  "keyboard_shortcuts.heading": "යතුරුපුවරු කෙටිමං",
  "keyboard_shortcuts.home": "මුල් පිටුව කාලරේඛාව විවෘත කරන්න",
  "keyboard_shortcuts.hotkey": "උණු යතුර",
  "keyboard_shortcuts.legend": "මෙම පුරාවෘත්තය පෙන්වන්න",
  "keyboard_shortcuts.local": "දේශීය කාලරේඛාව විවෘත කිරීමට",
  "keyboard_shortcuts.mention": "කතුවරයා සඳහන් කිරීමට",
  "keyboard_shortcuts.muted": "නිහඬ කළ අය පෙන්වන්න",
  "keyboard_shortcuts.my_profile": "ඔබගේ පැතිකඩ අරින්න",
  "keyboard_shortcuts.notifications": "දැනුම්දීම් තීරුව විවෘත කිරීමට",
  "keyboard_shortcuts.open_media": "මාධ්‍ය අරින්න",
  "keyboard_shortcuts.pinned": "ඇමිණූ ලිපි ලැයිස්තුව අරින්න",
  "keyboard_shortcuts.profile": "කතෘගේ පැතිකඩ අරින්න",
  "keyboard_shortcuts.reply": "පිළිතුරු දීමට",
  "keyboard_shortcuts.requests": "අනුගමනය කිරීමේ ඉල්ලීම් ලැයිස්තුව විවෘත කරන්න",
  "keyboard_shortcuts.search": "සෙවුම් තීරුව කෙරෙහි අවධානය යොමු කරන්න",
  "keyboard_shortcuts.spoilers": "CW ක්‍ෂේත්‍රය පෙන්වන්න/සඟවන්න",
  "keyboard_shortcuts.start": "\"පටන් ගන්න\" තීරුව අරින්න",
  "keyboard_shortcuts.toggle_hidden": "CW පිටුපස පෙළ පෙන්වන්න/සඟවන්න",
  "keyboard_shortcuts.toggle_sensitivity": "මාධ්‍ය පෙන්වන්න/සඟවන්න",
  "keyboard_shortcuts.toot": "නව ලිපියක් අරඹන්න",
  "keyboard_shortcuts.translate": "සටහනක් පරිවර්තනය කිරීමට",
  "keyboard_shortcuts.unfocus": "පෙළ ප්‍රදේශය/සෙවීම රචනා කිරීම නාභිගත නොකරන්න",
  "keyboard_shortcuts.up": "ලැයිස්තුවේ ඉහළට ගෙනයන්න",
  "lightbox.close": "වසන්න",
  "lightbox.next": "ඊළඟ",
  "lightbox.previous": "පෙර",
  "lightbox.zoom_in": "සැබෑ ප්‍රමාණයට විශාලනය කරන්න",
  "lightbox.zoom_out": "ගැළපීමට විශාලනය කරන්න",
  "limited_account_hint.action": "කෙසේ හෝ පැතිකඩ පෙන්වන්න",
  "limited_account_hint.title": "මෙම පැතිකඩ {domain}හි මධ්‍යස්ථකරුවන් විසින් සඟවා ඇත.",
  "link_preview.author": "{name}විසිනි",
  "link_preview.more_from_author": "{name}වෙතින් තවත්",
  "link_preview.shares": "{count, plural, one {{counter} සටහන} other {{counter} සටහන්}}",
  "lists.add_member": "එකතු කරන්න",
  "lists.add_to_list": "ලැයිස්තුවට එක් කරන්න",
  "lists.add_to_lists": "ලැයිස්තු වලට {name} එකතු කරන්න",
  "lists.create": "නිර්මාණය කරන්න",
  "lists.create_a_list_to_organize": "ඔබේ මුල් පිටුව සංග්‍රහය සංවිධානය කිරීමට නව ලැයිස්තුවක් සාදන්න",
  "lists.create_list": "ලැයිස්තුවක් සාදන්න",
  "lists.delete": "ලැයිස්තුව මකන්න",
  "lists.done": "කළා",
  "lists.edit": "ලැයිස්තුව සංස්කරණය",
  "lists.exclusive": "මුල් පිටුවේ සාමාජිකයන් සඟවන්න",
  "lists.exclusive_hint": "මෙම ලැයිස්තුවේ කෙනෙකු සිටී නම්, ඔවුන්ගේ සටහන් දෙවරක් නොදැකීමට ඔවුන්ව ඔබේ මුල් පිටුවේ සඟවන්න.",
  "lists.find_users_to_add": "එකතු කිරීමට පරිශීලකයින් සොයන්න",
  "lists.list_members_count": "{count, plural, one {# සාමාජිකයා} other {# සාමාජිකයා}}",
  "lists.list_name": "ලැයිස්තුවේ නම",
  "lists.new_list_name": "නව ලැයිස්තු නම",
  "lists.no_lists_yet": "තවම ලැයිස්තු නොමැත.",
  "lists.no_members_yet": "තවම සාමාජිකයන් නැත.",
  "lists.no_results_found": "ප්‍රතිඵල හමු නොවීය.",
  "lists.remove_member": "ඉවත් කරන්න",
  "lists.replies_policy.followed": "අනුගමනය කරන ඕනෑම පරිශීලකයෙක්",
  "lists.replies_policy.list": "ලැයිස්තුවේ සාමාජිකයින්",
  "lists.replies_policy.none": "කිසිවෙක් නැත",
  "lists.save": "සුරකින්න",
  "lists.search": "සෙවීම",
  "lists.show_replies_to": "ලැයිස්තු සාමාජිකයින්ගෙන් පිළිතුරු ඇතුළත් කරන්න",
  "load_pending": "{count, plural, one {# අලුත් අයිතමය} other {# අලුත් අයිතම}}",
  "loading_indicator.label": "…පූරණය වෙමින් පවතී",
  "media_gallery.hide": "සඟවන්න",
  "moved_to_account_banner.text": "ඔබ {movedToAccount}වෙත මාරු වූ නිසා ඔබගේ {disabledAccount} ගිණුම දැනට අක්‍රිය කර ඇත.",
  "mute_modal.hide_from_notifications": "දැනුම්දීම් වලින් සඟවන්න",
  "mute_modal.hide_options": "විකල්ප සඟවන්න",
  "mute_modal.indefinite": "මම ඒවා නිහඬ නොකරන තුරු",
  "mute_modal.show_options": "විකල්ප පෙන්වන්න",
  "mute_modal.they_can_mention_and_follow": "ඔවුන්ට ඔබව සඳහන් කර අනුගමනය කළ හැකිය, නමුත් ඔබට ඔවුන් නොපෙනේ.",
  "mute_modal.they_wont_know": "ඔවුන් නිහඬ කර ඇති බව ඔවුන් නොදනී.",
  "mute_modal.title": "පරිශීලකයා නිහඬ කරන්නද?",
  "mute_modal.you_wont_see_mentions": "ඒවා සඳහන් කරන සටහන් ඔබට නොපෙනේ.",
  "mute_modal.you_wont_see_posts": "ඔවුන්ට තවමත් ඔබේ සටහන් දැකිය හැකි නමුත්, ඔබට ඔවුන්ගේ සටහන් නොපෙනේ.",
  "navigation_bar.about": "පිළිබඳව",
  "navigation_bar.administration": "පරිපාලනය",
  "navigation_bar.advanced_interface": "උසස් වෙබ් අතුරු මුහුණතකින් විවෘත කරන්න",
  "navigation_bar.blocks": "අවහිර කළ අය",
  "navigation_bar.bookmarks": "පොත්යොමු",
  "navigation_bar.direct": "පෞද්ගලික සැඳහුම්",
  "navigation_bar.domain_blocks": "අවහිර කළ වසම්",
  "navigation_bar.favourites": "ප්‍රියතමයන්",
  "navigation_bar.filters": "නිහඬ කළ වචන",
  "navigation_bar.follow_requests": "අනුගමන ඉල්ලීම්",
  "navigation_bar.followed_tags": "අනුගමනය කළ හැෂ් ටැග්",
  "navigation_bar.follows_and_followers": "අනුගමන හා අනුගාමික",
  "navigation_bar.lists": "ලැයිස්තු",
  "navigation_bar.logout": "නික්මෙන්න",
  "navigation_bar.moderation": "මධ්‍යස්ථභාවය",
  "navigation_bar.mutes": "නිහඬ කළ අය",
  "navigation_bar.opened_in_classic_interface": "සම්භාව්‍ය වෙබ් අතුරුමුහුණත තුළ පළ කිරීම්, ගිණුම් සහ අනෙකුත් නිශ්චිත පිටු පෙරනිමියෙන් විවෘත වේ.",
  "navigation_bar.preferences": "අභිප්‍රේත",
  "navigation_bar.search": "සොයන්න",
  "not_signed_in_indicator.not_signed_in": "You need to sign in to access this resource.",
  "notification.admin.report": "{name} වාර්තා කර ඇත {target}",
  "notification.admin.report_statuses": "{category}සඳහා {name} {target} වාර්තා කරන ලදී",
  "notification.admin.report_statuses_other": "{name} වාර්තා කර ඇත {target}",
  "notification.admin.sign_up": "{name} ලියාපදිංචි විය",
  "notification.admin.sign_up.name_and_others": "{name} සහ {count, plural, one {# වෙනත්} other {# වෙනත්}} ලියාපදිංචි විය",
  "notification.annual_report.message": "ඔබේ {year} #Wrapstodon බලා සිටී! Mastodon හි ඔබේ වසරේ කැපී පෙනෙන අවස්ථා සහ අමතක නොවන අවස්ථා එළිදක්වන්න!",
  "notification.annual_report.view": "#රැප්ස්ටෝඩන් බලන්න",
  "notification.favourite": "{name} ඔබගේ ලිපියට ප්‍රිය කළා",
  "notification.favourite.name_and_others_with_link": "{name} සහ <a>{count, plural, one {# වෙනත්} other {# වෙනත්}}</a> ඔබේ සටහන ප්‍රියතම කළා.",
  "notification.favourite_pm": "{name} ඔබේ පෞද්ගලික සඳහන ප්‍රියතම කළා",
  "notification.favourite_pm.name_and_others_with_link": "{name} සහ <a>{count, plural, one {# වෙනත්} other {# වෙනත්}}</a> ඔබේ පුද්ගලික සඳහන ප්‍රියතම කළා",
  "notification.follow": "{name} ඔබව අනුගමනය කළා",
  "notification.follow.name_and_others": "{name} සහ <a>{count, plural, one {# වෙනත්} other {# වෙනත්}}</a> ඔබව අනුගමනය කළා",
  "notification.follow_request": "{name} ඔබව අනුගමනය කිරීමට ඉල්ලා ඇත.",
  "notification.follow_request.name_and_others": "{name} සහ {count, plural, one {# වෙනත්} other {# වෙනත්}} ඔබව අනුගමනය කිරීමට ඉල්ලා ඇත.",
  "notification.label.mention": "සඳහන් කිරීම",
  "notification.label.private_mention": "පුද්ගලික සඳහන",
  "notification.label.private_reply": "පුද්ගලික පිළිතුර",
  "notification.label.reply": "පිළිතුරු දෙන්න",
  "notification.mention": "සඳහන් කිරීම",
  "notification.mentioned_you": "{name} ඔබව සඳහන් කළා",
  "notification.moderation-warning.learn_more": "තවත් හදාරන්න",
  "notification.moderation_warning": "ඔබට මධ්‍යස්ථකරණ අනතුරු ඇඟවීමක් ලැබී ඇත.",
  "notification.moderation_warning.action_delete_statuses": "ඔබගේ සමහර සටහන් ඉවත් කර ඇත.",
  "notification.moderation_warning.action_disable": "ඔබගේ ගිණුම අක්‍රිය කර ඇත.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "ඔබගේ සමහර සටහන් සංවේදී ලෙස සලකුණු කර ඇත.",
  "notification.moderation_warning.action_none": "ඔබගේ ගිණුමට මධ්‍යස්ථකරණ අනතුරු ඇඟවීමක් ලැබී ඇත.",
  "notification.moderation_warning.action_sensitive": "මෙතැන් සිට ඔබගේ සටහන් සංවේදී ලෙස සලකුණු කෙරේ.",
  "notification.moderation_warning.action_silence": "ඔබගේ ගිණුම සීමා කර ඇත.",
  "notification.moderation_warning.action_suspend": "ඔබගේ ගිණුම අත්හිටුවා ඇත.",
  "notification.own_poll": "ඔබගේ මත විමසුම නිමයි",
  "notification.poll": "ඔබ ඡන්දය දුන් මත විමසුමක් අවසන් විය.",
  "notification.reblog": "{name} ඔබේ සටහන වැඩි කළා",
  "notification.reblog.name_and_others_with_link": "{name} සහ <a>{count, plural, one {# වෙනත්} other {# වෙනත්}}</a> ඔබේ සටහන බූස්ට් කළා",
  "notification.relationships_severance_event": "{name}සමඟ සම්බන්ධතා නැති විය",
  "notification.relationships_severance_event.account_suspension": "{from} හි පරිපාලකයෙකු {target}අත්හිටුවා ඇත, එයින් අදහස් වන්නේ ඔබට තවදුරටත් ඔවුන්ගෙන් යාවත්කාලීන ලබා ගැනීමට හෝ ඔවුන් සමඟ අන්තර් ක්‍රියා කිරීමට නොහැකි බවයි.",
  "notification.relationships_severance_event.domain_block": "{from} හි පරිපාලකයෙකු {target}අවහිර කර ඇත, එයට ඔබගේ අනුගාමිකයින් {followersCount} සහ ඔබ අනුගමනය කරන {followingCount, plural, one {# ගිණුම} other {# ගිණුම්}} ඇතුළත් වේ.",
  "notification.relationships_severance_event.learn_more": "තවත් හදාරන්න",
  "notification.relationships_severance_event.user_domain_block": "ඔබ {target}අවහිර කර ඇති අතර, ඔබගේ අනුගාමිකයින් {followersCount} ක් සහ ඔබ අනුගමනය කරන {followingCount, plural, one {# ගිණුම} other {# ගිණුම්}} ක් ඉවත් කර ඇත.",
  "notification.status": "{name} දැන් පළ කළා",
  "notification.update": "{name} ලිපියක් සංස්කරණය කළා",
  "notification_requests.accept": "පිළිගන්න",
  "notification_requests.accept_multiple": "{count, plural, one {# ඉල්ලීම පිළිගන්න…} other {ඉල්ලීම් # පිළිගන්න…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {ඉල්ලීම පිළිගන්න} other {ඉල්ලීම් පිළිගන්න}}",
  "notification_requests.confirm_accept_multiple.message": "ඔබ {count, plural, one {එක දැනුම්දීමේ ඉල්ලීමක්} other {පිළිගැනීමට ආසන්නයි # දැනුම්දීම් ඉල්ලීම්}}. ඔබට ඉදිරියට යාමට අවශ්‍ය බව විශ්වාසද?",
  "notification_requests.confirm_accept_multiple.title": "දැනුම්දීම් ඉල්ලීම් පිළිගන්නවාද?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {ඉල්ලීම ඉවත ලන්න} other {ඉල්ලීම් ඉවත ලන්න}}",
  "notification_requests.confirm_dismiss_multiple.message": "ඔබ {count, plural, one {එක් දැනුම්දීමේ ඉල්ලීමක්} other {# දැනුම්දීම් ඉල්ලීම්}}ඉවත දැමීමට ආසන්නයි. ඔබට {count, plural, one {එය} other {ඒවා}} වෙත නැවත පහසුවෙන් ප්‍රවේශ වීමට නොහැකි වනු ඇත. ඔබට ඉදිරියට යාමට අවශ්‍ය බව ඔබට විශ්වාසද?",
  "notification_requests.confirm_dismiss_multiple.title": "දැනුම්දීම් ඉල්ලීම් ඉවත දමන්නද?",
  "notification_requests.dismiss": "ඉවතලන්න",
  "notification_requests.dismiss_multiple": "{count, plural, one {ඉවත ලන්න # ඉල්ලීම…} other {ඉවත ලන්න # ඉල්ලීම්…}}",
  "notification_requests.edit_selection": "සංස්කරණය කරන්න",
  "notification_requests.exit_selection": "කළා",
  "notification_requests.explainer_for_limited_account": "ගිණුම මධ්‍යස්ථකරුවෙකු විසින් සීමා කර ඇති බැවින් මෙම ගිණුමෙන් ලැබෙන දැනුම්දීම් පෙරහන් කර ඇත.",
  "notification_requests.explainer_for_limited_remote_account": "ගිණුම හෝ එහි සේවාදායකය මධ්‍යස්ථකරුවෙකු විසින් සීමා කර ඇති බැවින් මෙම ගිණුමෙන් ලැබෙන දැනුම්දීම් පෙරහන් කර ඇත.",
  "notification_requests.maximize": "උපරිම කරන්න",
  "notification_requests.minimize_banner": "පෙරහන් කළ දැනුම්දීම් බැනරය අවම කරන්න",
  "notification_requests.notifications_from": "{name}වෙතින් දැනුම්දීම්",
  "notification_requests.title": "පෙරහන් කළ දැනුම්දීම්",
  "notification_requests.view": "දැනුම්දීම් බලන්න",
  "notifications.clear": "දැනුම්දීම් මකන්න",
  "notifications.clear_confirmation": "දැනුම්දීම් සියල්ල හිස් කිරීමට වුවමනා ද?",
  "notifications.clear_title": "දැනුම්දීම් හිස් කරන්නද?",
  "notifications.column_settings.admin.report": "නව වාර්තා:",
  "notifications.column_settings.admin.sign_up": "නව ලියාපදිංචි:",
  "notifications.column_settings.alert": "වැඩතල දැනුම්දීම්",
  "notifications.column_settings.favourite": "ප්‍රියතමයන්:",
  "notifications.column_settings.filter_bar.advanced": "සියලුම කාණ්ඩ පෙන්වන්න",
  "notifications.column_settings.filter_bar.category": "ඉක්මන් පෙරහන් තීරුව",
  "notifications.column_settings.follow": "නව අනුගාමිකයින්:",
  "notifications.column_settings.follow_request": "නව අනුගමන ඉල්ලීම්:",
  "notifications.column_settings.group": "සමූහය",
  "notifications.column_settings.mention": "සැඳහුම්:",
  "notifications.column_settings.poll": "මත විමසුමේ ප්‍රතිඵල:",
  "notifications.column_settings.push": "තල්ලු දැනුම්දීම්",
  "notifications.column_settings.reblog": "බූස්ට්:",
  "notifications.column_settings.show": "තීරුවෙහි පෙන්වන්න",
  "notifications.column_settings.sound": "ශබ්දය වාදනය",
  "notifications.column_settings.status": "නව ලිපි:",
  "notifications.column_settings.unread_notifications.category": "නොකියවූ දැනුම්දීම්",
  "notifications.column_settings.unread_notifications.highlight": "නොකියවූ දැනුම්දීම් ඉස්මතු කරන්න",
  "notifications.column_settings.update": "සංශෝධන:",
  "notifications.filter.all": "සියල්ල",
  "notifications.filter.boosts": "වැඩි කරයි",
  "notifications.filter.favourites": "ප්‍රියතමයන්",
  "notifications.filter.follows": "අනුගමනය",
  "notifications.filter.mentions": "සැඳහුම්",
  "notifications.filter.polls": "මත විමසුමේ ප්‍රතිඵල",
  "notifications.filter.statuses": "ඔබ අනුගමනය කරන පුද්ගලයින්ගෙන් යාවත්කාලීන කිරීම්",
  "notifications.grant_permission": "අවසර දෙන්න.",
  "notifications.group": "දැනුම්දීම් {count}",
  "notifications.mark_as_read": "සියළු දැනුම්දීම් කියවූ බව යොදන්න",
  "notifications.permission_denied": "කලින් ප්‍රතික්ෂේප කරන ලද බ්‍රව්සර් අවසර ඉල්ලීම නිසා ඩෙස්ක්ටොප් දැනුම්දීම් ලබා ගත නොහැක.",
  "notifications.permission_denied_alert": "බ්‍රවුසර අවසරය කලින් ප්‍රතික්ෂේප කර ඇති බැවින්, ඩෙස්ක්ටොප් දැනුම්දීම් සක්‍රීය කළ නොහැක.",
  "notifications.permission_required": "අවශ්‍ය අවසරය ලබා දී නොමැති නිසා ඩෙස්ක්ටොප් දැනුම්දීම් ලබා ගත නොහැක.",
  "notifications.policy.accept": "පිළිගන්න",
  "notifications.policy.accept_hint": "දැනුම්දීම් තුළ පෙන්වන්න",
  "notifications.policy.drop": "නොසලකා හරින්න",
  "notifications.policy.drop_hint": "නැවත කිසිදා නොපෙනී, හිස්තැනට යවන්න.",
  "notifications.policy.filter": "පෙරහන",
  "notifications.policy.filter_hint": "පෙරහන් කළ දැනුම්දීම් එන ලිපි වෙත යවන්න",
  "notifications.policy.filter_limited_accounts_hint": "සේවාදායක මධ්‍යස්ථකරුවන් විසින් සීමා කර ඇත.",
  "notifications.policy.filter_limited_accounts_title": "මධ්‍යස්ථ ගිණුම්",
  "notifications.policy.filter_new_accounts.hint": "අතීතය තුළ නිර්මාණය කරන ලදී {days, plural, one {එක් දිනක්} other {# දින}}",
  "notifications.policy.filter_new_accounts_title": "නව ගිණුම්",
  "notifications.policy.filter_not_followers_hint": "{days, plural, one {ට වඩා අඩුවෙන් ඔබව අනුගමනය කරන පුද්ගලයින් ඇතුළුව, එක් දිනක්} other {# දින}}",
  "notifications.policy.filter_not_followers_title": "ඔබව අනුගමනය නොකරන පුද්ගලයින්",
  "notifications.policy.filter_not_following_hint": "ඔබ ඒවා හස්තීයව අනුමත කරන තුරු",
  "notifications.policy.filter_not_following_title": "ඔබ අනුගමනය නොකරන පුද්ගලයින්",
  "notifications.policy.filter_private_mentions_hint": "ඔබේම සඳහන් කිරීමට පිළිතුරක් ලෙස හෝ ඔබ යවන්නා අනුගමනය කරන්නේ නම් මිස පෙරහන් කර ඇත.",
  "notifications.policy.filter_private_mentions_title": "අයාචිත පෞද්ගලික සඳහන් කිරීම්",
  "notifications.policy.title": "…සිට දැනුම්දීම් කළමනාකරණය කරන්න",
  "notifications_permission_banner.enable": "වැඩතල දැනුම්දීම් සබල කරන්න",
  "notifications_permission_banner.how_to_control": "Mastodon විවෘතව නොමැති විට දැනුම්දීම් ලබා ගැනීමට, ඩෙස්ක්ටොප් දැනුම්දීම් සක්‍රීය කරන්න. ඒවා සක්‍රීය කළ පසු ඉහත {icon} බොත්තම හරහා ඩෙස්ක්ටොප් දැනුම්දීම් ජනනය කරන්නේ කුමන ආකාරයේ අන්තර්ක්‍රියාද යන්න ඔබට නිශ්චිතවම පාලනය කළ හැකිය.",
  "notifications_permission_banner.title": "කිසිවක් අතපසු නොකරන්න",
  "onboarding.follows.back": "ආපසු",
  "onboarding.follows.empty": "අවාසනාවකට, දැන් ප්‍රතිඵල කිසිවක් පෙන්විය නොහැක. අනුගමනය කිරීමට පුද්ගලයින් සොයා ගැනීමට ඔබට සෙවීම භාවිතා කිරීමට හෝ ගවේෂණ පිටුව බ්‍රවුස් කිරීමට උත්සාහ කළ හැකිය, නැතහොත් පසුව නැවත උත්සාහ කරන්න.",
  "onboarding.follows.search": "සෙවීම",
  "onboarding.follows.title": "ආරම්භ කිරීමට පුද්ගලයින් අනුගමනය කරන්න",
  "onboarding.profile.discoverable": "මගේ පැතිකඩ සොයා ගත හැකි කරන්න",
  "onboarding.profile.discoverable_hint": "ඔබ Mastodon හි සොයාගැනීමේ හැකියාව තෝරා ගත් විට, ඔබේ සටහන් සෙවුම් ප්‍රතිඵලවල සහ ප්‍රවණතාවල දිස්විය හැකි අතර, ඔබට සමාන උනන්දුවක් ඇති පුද්ගලයින්ට ඔබේ පැතිකඩ යෝජනා කළ හැකිය.",
  "onboarding.profile.display_name": "ප්රදර්ශන නාමය",
  "onboarding.profile.display_name_hint": "ඔබේ සම්පූර්ණ නම හෝ ඔබේ විනෝදජනක නම…",
  "onboarding.profile.note": "ජෛව",
  "onboarding.profile.note_hint": "ඔබට වෙනත් පුද්ගලයින් හෝ #හැෂ් ටැග්…@සඳහන් කළ හැක.",
  "onboarding.profile.title": "පැතිකඩ සැකසුම",
  "onboarding.profile.upload_avatar": "පැතිකඩ පින්තූරය උඩුගත කරන්න",
  "onboarding.profile.upload_header": "පැතිකඩ ශීර්ෂය උඩුගත කරන්න",
  "password_confirmation.exceeds_maxlength": "මුරපද තහවුරු කිරීම උපරිම මුරපදයේ දිග ඉක්මවයි.",
  "password_confirmation.mismatching": "මුරපද තහවුරු කිරීම නොගැලපේ.",
  "picture_in_picture.restore": "ඒක ආපහු දාන්න.",
  "poll.closed": "වසා ඇත",
  "poll.refresh": "නැවුම් කරන්න",
  "poll.reveal": "ප්‍රතිඵල බලන්න",
  "poll.total_people": "{count, plural, one {# පුද්ගලයා} other {# පුද්ගලයින්}}",
  "poll.total_votes": "{count, plural, one {# ඡන්දය} other {# ඡන්ද}}",
  "poll.vote": "ඡන්දය",
  "poll.voted": "ඔබ මෙම උත්තරයට ඡන්දය දී ඇත",
  "poll.votes": "{votes, plural, one {# ඡන්දය} other {# ඡන්ද}}",
  "poll_button.add_poll": "මත විමසුමක් අරඹන්න",
  "poll_button.remove_poll": "මත විමසුම ඉවතලන්න",
  "privacy.change": "ලිපියේ රහස්‍යතාව සංශෝධනය",
  "privacy.direct.long": "සටහනේ සඳහන් කළ සියලු දෙනාම",
  "privacy.direct.short": "පුද්ගලික සඳහන",
  "privacy.private.long": "ඔබේ අනුගාමිකයින් පමණයි",
  "privacy.private.short": "අනුගාමිකයින්",
  "privacy.public.long": "මැස්ටෝඩන් වල සහ ඉන් පිටත ඕනෑම අයෙක්",
  "privacy.public.short": "ප්‍රසිද්ධ",
  "privacy.unlisted.additional": "මෙය හරියටම පොදු ලෙසම ක්‍රියා කරයි, ඔබ ගිණුම පුරා තෝරාගෙන සිටියත්, සජීවී සංග්‍රහ හෝ හැෂ් ටැග්, ගවේෂණය හෝ මැස්ටෝඩන් සෙවුම තුළ පළ කිරීම දිස් නොවේ.",
  "privacy.unlisted.short": "නිහඬ මහජනතාව",
  "privacy_policy.last_updated": "අවසන් වරට යාවත්කාලීන කරන ලද්දේ {date}",
  "privacy_policy.title": "රහස්‍යතා ප්‍රතිපත්තිය",
  "recommended": "නිර්දේශිත",
  "refresh": "නැවුම් කරන්න",
  "regeneration_indicator.please_stand_by": "කරුණාකර රැඳී සිටින්න.",
  "regeneration_indicator.preparing_your_home_feed": "ඔබේ නිවසේ සංග්‍රහය සූදානම් කරමින්…",
  "relative_time.days": "ද. {number}",
  "relative_time.full.days": "{number, plural, one {දවස් #} other {දවස් #}} කට පෙර",
  "relative_time.full.hours": "{number, plural, one {පැය #} other {පැය #}} කට පෙර",
  "relative_time.full.just_now": "මේ දැන්",
  "relative_time.full.minutes": "{number, plural, one {විනාඩි #} other {විනාඩි #}} කට පෙර",
  "relative_time.full.seconds": "{number, plural, one {තත්පර #} other {තත්පර #}} කට පෙර",
  "relative_time.hours": "පැය {number}",
  "relative_time.just_now": "දැන්",
  "relative_time.minutes": "වි. {number}",
  "relative_time.seconds": "තත්. {number}",
  "relative_time.today": "අද",
  "reply_indicator.attachments": "{count, plural, one {# ඇමුණුම} other {# ඇමුණුම්}}",
  "reply_indicator.cancel": "අවලංගු කරන්න",
  "reply_indicator.poll": "මත විමසුම",
  "report.block": "අවහිර",
  "report.block_explanation": "ඔබට ඔවුන්ගේ සටහන් නොපෙනේ. ඔවුන්ට ඔබේ සටහන් දැකීමට හෝ ඔබව අනුගමනය කිරීමට නොහැකි වනු ඇත. ඔවුන් අවහිර කර ඇති බව ඔවුන්ට දැනගත හැකි වනු ඇත.",
  "report.categories.legal": "නීතිමය",
  "report.categories.other": "වෙනත්",
  "report.categories.spam": "ආයාචිත",
  "report.categories.violation": "අන්තර්ගතය නිසා සේවාදායකයේ නීතියක් හෝ කිහිපයක් කඩ වේ",
  "report.category.subtitle": "හොඳම ගැලපීම තෝරන්න",
  "report.category.title": "මෙම {type}සමඟ සිදුවන්නේ කුමක්දැයි අපට කියන්න",
  "report.category.title_account": "පැතිකඩ",
  "report.category.title_status": "ලිපිය",
  "report.close": "අහවරයි",
  "report.comment.title": "අප දැනගත යුතු යැයි ඔබ සිතන තවත් යමක් තිබේද?",
  "report.forward": "{target} වෙත හරවන්න",
  "report.forward_hint": "ගිණුම වෙනත් සේවාදායකයකින්. වාර්තාවේ නිර්නාමික පිටපතක් එතනටත් එවන්න?",
  "report.mute": "නිහඬ",
  "report.mute_explanation": "ඔබ ඔවුන්ගේ ලිපි නොදකිනු ඇත. ඔවුන්ට තවමත් ඔබව අනුගමනයට සහ ඔබගේ ලිපි දැකීමට හැකි අතර ඔවුන්ව නිහඬ කර ඇති බව දැන ගැනීමට නොහැකිය.",
  "report.next": "ඊළඟ",
  "report.placeholder": "අමතර අදහස්",
  "report.reasons.dislike": "මම එයට අකැමතියි",
  "report.reasons.dislike_description": "ඒක බලන්න ඕන දෙයක් නෙවෙයි",
  "report.reasons.legal": "එය නීති විරෝධීයි.",
  "report.reasons.legal_description": "එය ඔබගේ හෝ සේවාදායකයාගේ රටේ නීතිය උල්ලංඝනය කරන බව ඔබ විශ්වාස කරයි නම්",
  "report.reasons.other": "එය වෙනත් දෙයක්",
  "report.reasons.other_description": "ගැටළුව වෙනත් වර්ග වලට නොගැලපේ",
  "report.reasons.spam": "එය අයාචිතයි",
  "report.reasons.spam_description": "අනිෂ්ට සබැඳි, ව්‍යාජ නියැලීම, හෝ පුනරාවර්තන පිළිතුරු",
  "report.reasons.violation": "එය සේවාදායකයේ නීති කඩ කරයි",
  "report.reasons.violation_description": "එය නිශ්චිත නීති කඩ කරන බව ඔබ දන්නවා",
  "report.rules.subtitle": "අදාළ සියල්ල තෝරන්න",
  "report.rules.title": "කුමන නීති උල්ලංඝනය කරන්නේද?",
  "report.statuses.subtitle": "අදාළ සියල්ල තෝරන්න",
  "report.statuses.title": "මෙම වාර්තාව උපස්ථ කළ ලිපි තිබේ ද?",
  "report.submit": "යොමන්න",
  "report.target": "{target} වාර්තා කිරීම",
  "report.thanks.take_action": "මාස්ටඩන් හි ඔබ දකින දෑ පාලනයට තිබෙන විකල්ප:",
  "report.thanks.take_action_actionable": "අපි මෙය සමාලෝචනය කරන අතරතුර, ඔබට @{name}ට එරෙහිව පියවර ගත හැක:",
  "report.thanks.title": "මෙය නොපෙන්විය යුතුද?",
  "report.thanks.title_actionable": "වාර්තා කිරීමට ස්තූතියි, අපි මේ ගැන සොයා බලමු.",
  "report.unfollow": "@{name}අනුගමනය නොකරන්න",
  "report.unfollow_explanation": "ඔබ මෙම ගිණුම අනුගමනය කරයි. ඔබගේ මුල් පිටුවේ ඔවුන්ගේ ලිපි නොදැකීමට, ඔවුන්ව තවදුරටත් අනුගමනය නොකරන්න.",
  "report_notification.attached_statuses": "{count, plural, one {ලිපි {count}} other {ලිපි {count} ක්}} අමුණා ඇත",
  "report_notification.categories.legal": "නීතිමය",
  "report_notification.categories.legal_sentence": "නීති විරෝධී අන්තර්ගතය",
  "report_notification.categories.other": "වෙනත්",
  "report_notification.categories.other_sentence": "වෙනත්",
  "report_notification.categories.spam": "ආයාචිත",
  "report_notification.categories.spam_sentence": "ආයාචිත තැපැල්",
  "report_notification.categories.violation": "නීතිය කඩ කිරීම",
  "report_notification.categories.violation_sentence": "නීති උල්ලංඝනය",
  "report_notification.open": "විවෘත වාර්තාව",
  "search.no_recent_searches": "මෑත සෙවීම් නැත",
  "search.placeholder": "සොයන්න",
  "search.quick_action.account_search": "ගැළපෙන පැතිකඩ {x}",
  "search.quick_action.go_to_account": "{x} පැතිකඩ වෙත යන්න",
  "search.quick_action.go_to_hashtag": "{x}හැෂ් ටැගය වෙත යන්න",
  "search.quick_action.open_url": "ලිපිනය මාස්ටඩන්හි අරින්න",
  "search.quick_action.status_search": "ගැළපෙන ලිපි {x}",
  "search.search_or_paste": "සොයන්න හෝ ඒ.ස.නි. අලවන්න",
  "search_popout.full_text_search_disabled_message": "{domain}හි නොමැත.",
  "search_popout.full_text_search_logged_out_message": "පුරනය වූ විට පමණක් ලබා ගත හැක.",
  "search_popout.language_code": "ISO භාෂා කේතය",
  "search_popout.options": "සෙවුම් විකල්ප",
  "search_popout.quick_actions": "ඉක්මන් ක්‍රියාමාර්ග",
  "search_popout.recent": "මෑත සෙවීම්",
  "search_popout.specific_date": "නිශ්චිත දිනයකට",
  "search_popout.user": "පරිශ්‍රීලකයා",
  "search_results.accounts": "පැතිකඩ",
  "search_results.all": "සියල්ල",
  "search_results.hashtags": "හැෂ් ටැග්",
  "search_results.no_results": "ප්‍රති results ල නැහැ.",
  "search_results.no_search_yet": "සටහන්, පැතිකඩ හෝ හැෂ් ටැග් සෙවීමට උත්සාහ කරන්න.",
  "search_results.see_all": "සියල්ල බලන්න",
  "search_results.statuses": "ලිපි",
  "search_results.title": "\"{q}\" සඳහා සොයන්න",
  "server_banner.about_active_users": "පසුගිය දින 30 තුළ මෙම සේවාදායකය භාවිතා කළ පුද්ගලයින් (මාසික ක්‍රියාකාරී පරිශීලකයින්)",
  "server_banner.active_users": "සක්‍රිය පරිශ්‍රීලකයින්",
  "server_banner.administered_by": "පරිපාලනය කරනු ලබන්නේ:",
  "server_banner.is_one_of_many": "{domain} යනු ඔබට fediverse එකට සහභාගී වීමට භාවිතා කළ හැකි බොහෝ ස්වාධීන Mastodon සේවාදායකයන්ගෙන් එකකි.",
  "server_banner.server_stats": "සේවාදායක සංඛ්‍යාලේඛන:",
  "sign_in_banner.create_account": "ගිණුමක් සාදන්න",
  "sign_in_banner.follow_anyone": "ෆෙඩිවර්ස් හරහා ඕනෑම අයෙකු අනුගමනය කර ඒ සියල්ල කාලානුක්‍රමික අනුපිළිවෙලින් බලන්න. ඇල්ගොරිතම, දැන්වීම් හෝ ක්ලික්බයිට් කිසිවක් පෙනෙන්නට නැත.",
  "sign_in_banner.mastodon_is": "සිදුවන දේ පිළිබඳව දැනුවත් වීමට හොඳම ක්‍රමය මැස්ටෝඩන් ය.",
  "sign_in_banner.sign_in": "පිවිසෙන්න",
  "sign_in_banner.sso_redirect": "පුරනය වන්න හෝ ලියාපදිංචි වන්න",
  "status.admin_account": "@{name}සඳහා මධ්‍යස්ථකරණ අතුරුමුහුණත විවෘත කරන්න",
  "status.admin_domain": "{domain}සඳහා මධ්‍යස්ථකරණ අතුරුමුහුණත විවෘත කරන්න",
  "status.admin_status": "මෙම ලිපිය මැදිහත්කරණ අතුරුමුහුණතෙහි අරින්න",
  "status.block": "@{name} අවහිර",
  "status.bookmark": "පොත්යොමුවක්",
  "status.cancel_reblog_private": "බූස්ට් ඉවත් කරන්න",
  "status.cannot_reblog": "මෙම පළ කිරීම වැඩි කළ නොහැක.",
  "status.continued_thread": "අඛණ්ඩ නූල",
  "status.copy": "ලිපියට සබැඳියේ පිටපතක්",
  "status.delete": "මකන්න",
  "status.detailed_status": "විස්තරාත්මක සංවාද දැක්ම",
  "status.direct": "පෞද්ගලිකව @{name}සඳහන් කරන්න",
  "status.direct_indicator": "පුද්ගලික සඳහන",
  "status.edit": "සංස්කරණය",
  "status.edited": "අවසන් වරට සංස්කරණය කරන ලද්දේ {date}",
  "status.edited_x_times": "සංශෝධිතයි {count, plural, one {වාර {count}} other {වාර {count}}}",
  "status.embed": "කාවැද්දූ කේතය ලබා ගන්න",
  "status.favourite": "ප්‍රියතම",
  "status.filter": "මෙම ලිපිය පෙරන්න",
  "status.history.created": "{name} නිර්මාණය {date}",
  "status.history.edited": "{name} සංස්කරණය {date}",
  "status.load_more": "තව පූරණය",
  "status.media.open": "විවෘත කිරීමට ක්ලික් කරන්න",
  "status.media.show": "පෙන්වීමට ක්ලික් කරන්න",
  "status.media_hidden": "මාධ්‍ය සඟවා ඇත",
  "status.mention": "@{name} සඳහන් කරන්ක",
  "status.more": "තව",
  "status.mute": "@{name} නිහඬව",
  "status.mute_conversation": "සංවාදය නිහඬව",
  "status.open": "මෙම ලිපිය විහිදන්න",
  "status.pin": "පැතිකඩට අමුණන්න",
  "status.read_more": "තව කියවන්න",
  "status.reblog": "බූස්ට් කරන්න",
  "status.reblogged_by": "{name} වැඩි කරන ලදී",
  "status.reblogs.empty": "මෙම සටහන තවම කිසිවෙකු බූස්ට් කර නැත. යමෙකු එසේ කළ විට, ඔවුන් මෙහි පෙන්වනු ඇත.",
  "status.redraft": "& නැවත කෙටුම්පත මකන්න",
  "status.remove_bookmark": "පොත්යොමුව ඉවතලන්න",
  "status.remove_favourite": "ප්‍රියතමයන්ගෙන් ඉවත් කරන්න",
  "status.replied_in_thread": "නූලෙහි පිළිතුරු දෙන ලදී",
  "status.replied_to": "{name}ට පිළිතුරු දුන්නා",
  "status.reply": "පිළිතුරු",
  "status.replyAll": "නූලට පිළිතුරු දෙන්න",
  "status.report": "@{name} වාර්තා කරන්න",
  "status.sensitive_warning": "සංවේදී අන්තර්ගතයකි",
  "status.share": "බෙදාගන්න",
  "status.show_less_all": "සියල්ල අඩුවෙන් පෙන්වන්න",
  "status.show_more_all": "සියල්ල වැඩියෙන් පෙන්වන්න",
  "status.show_original": "මුල් පිටපත පෙන්වන්න",
  "status.title.with_attachments": "{user} පළ කරන ලදී {attachmentCount, plural, one {ඇමුණුමක්} other {{attachmentCount} ඇමුණුම්}}",
  "status.translate": "පරිවර්තනය",
  "status.translated_from_with": "{provider} මගින් {lang} භාෂාවෙන් පරිවර්තනය කර ඇත",
  "status.uncached_media_warning": "පෙරදසුන නැත",
  "status.unmute_conversation": "සංවාදය නොනිහඬ",
  "status.unpin": "පැතිකඩෙන් ගළවන්න",
  "subscribed_languages.lead": "වෙනස් කිරීමෙන් පසු තෝරාගත් භාෂාවලින් පළ කිරීම් පමණක් ඔබගේ මුල් පිටුවේ සහ ලැයිස්තු කාලරේඛාවල දිස්වනු ඇත. සියලුම භාෂාවලින් පළ කිරීම් ලැබීමට කිසිවක් තෝරන්න.",
  "subscribed_languages.save": "වෙනස්කම් සුරකින්න",
  "subscribed_languages.target": "{target}සඳහා දායක වූ භාෂා වෙනස් කරන්න.",
  "tabs_bar.home": "මුල් පිටුව",
  "tabs_bar.notifications": "දැනුම්දීම්",
  "terms_of_service.effective_as_of": "{date}සිට ක්‍රියාත්මක වේ",
  "terms_of_service.title": "සේවා කොන්දේසි",
  "terms_of_service.upcoming_changes_on": "{date}දින ඉදිරියේදී සිදුවන වෙනස්කම්",
  "time_remaining.days": "{number, plural, one {දවස් #} other {දවස් #}} ක් ඉතිරිය",
  "time_remaining.hours": "{number, plural, one {පැය #} other {පැය #}} ක් ඉතිරිය",
  "time_remaining.minutes": "{number, plural, one {විනාඩි #} other {විනාඩි #}} ක් ඉතිරිය",
  "time_remaining.moments": "ඉතිරිව ඇති මොහොත",
  "time_remaining.seconds": "{number, plural, one {තත්පර #} other {තත්පර #}} ක් ඉතිරිය",
  "trends.counter_by_accounts": "{count, plural, one {{counter} පුද්ගලයා} other {{counter} අතීතයේ පුද්ගලයින්}} දින {days, plural, one {දින} other {{days} දින}}",
  "trends.trending_now": "දැන් නැගී එන",
  "ui.beforeunload": "ඔබ මාස්ටඩන් හැර ගියහොත් කටුපිටපත අහිමි වේ.",
  "units.short.billion": "{count}බී",
  "units.short.million": "ද.ල. {count}",
  "units.short.thousand": "{count}කි",
  "upload_area.title": "උඩුගතයට ඇද දමන්න",
  "upload_button.label": "රූප, දෘශ්‍යක හෝ හඬපට අමුණන්න",
  "upload_error.limit": "සීමාව ඉක්මවා ඇත.",
  "upload_error.poll": "මත විමසුම් සමඟ ගොනු යෙදීමට ඉඩ නොදේ.",
  "upload_form.drag_and_drop.instructions": "මාධ්‍ය ඇමුණුමක් ලබා ගැනීමට, space හෝ enter ඔබන්න. ඇදගෙන යන අතරතුර, ඊතල යතුරු භාවිතා කර මාධ්‍ය ඇමුණුම ඕනෑම දිශාවකට ගෙන යන්න. මාධ්‍ය ඇමුණුම එහි නව ස්ථානයට දැමීමට space හෝ enter ඔබන්න, නැතහොත් අවලංගු කිරීමට escape ඔබන්න.",
  "upload_form.drag_and_drop.on_drag_cancel": "ඇදගෙන යාම අවලංගු කරන ලදී. මාධ්‍ය ඇමුණුම {item} ඉවත් කරන ලදී.",
  "upload_form.drag_and_drop.on_drag_end": "මාධ්‍ය ඇමුණුම {item} ඉවත් කරන ලදී.",
  "upload_form.drag_and_drop.on_drag_over": "මාධ්‍ය ඇමුණුම {item} ගෙන යන ලදී.",
  "upload_form.drag_and_drop.on_drag_start": "මාධ්‍ය ඇමුණුම {item}ලබා ගත්තා.",
  "upload_form.edit": "සංස්කරණය",
  "upload_progress.label": "උඩුගත වෙමින්...",
  "upload_progress.processing": "සැකසෙමින්…",
  "username.taken": "නම දැනටමත් අරගෙන ඇත",
  "video.close": "දෘශ්‍යකය වසන්න",
  "video.download": "ගොනුව බාගන්න",
  "video.exit_fullscreen": "පූර්ණ තිරයෙන් පිටවන්න",
  "video.expand": "දෘශ්‍යකය විහිදන්න",
  "video.fullscreen": "පූර්ණ තිරය",
  "video.hide": "දෘශ්‍යකය සඟවන්න",
  "video.mute": "නිහඬ කරන්න",
  "video.pause": "විරාමය",
  "video.play": "ධාවනය",
  "video.skip_backward": "පසුපසට මඟ හරින්න",
  "video.skip_forward": "ඉදිරියට මඟ හරින්න",
  "video.unmute": "නිහඬ නොකරන්න",
  "video.volume_down": "ශබ්දය අඩු කරන්න",
  "video.volume_up": "ශබ්දය වැඩි කරන්න"
}
